// extracted by mini-css-extract-plugin
export default {"wrapperLoader":"Loader_wrapperLoader__AYpg-","loader1":"Loader_loader1__lICus","loader2":"Loader_loader2__ckGSU","rotate":"Loader_rotate__gKfUU"};